// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__1zKtp","mobile-hide":"styles-m__mobile-hide__GpHRX","line-separater":"styles-m__line-separater__3Uin_","skip-line":"styles-m__skip-line__256q0"};